import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';
import { detectIconById } from '../common/enum';
import {numeralFormat} from '../common/numeralFormat';

const ACTIONS_PLAYER = {
    GET_PLAYER_CONDITION_PITCHER_SUCCESS: 'GET_PLAYER_CONDITION_PITCHER_SUCCESS',
    GET_PLAYER_CONDITION_PITCHER_ERROR: 'GET_PLAYER_CONDITION_PITCHER_ERROR'
};

const updateStatus = (type, data) => ({
    type,
    data,
});

const getPlayerConditionPitcher = (player_id, date_from, date_to) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    let url = `${host.serverTest}api/players/${player_id}/results/categories/types/pitcher?from=${date_from}&to=${date_to}`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                dispatch(updateStatus(ACTIONS_PLAYER.GET_PLAYER_CONDITION_PITCHER_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS_PLAYER.GET_PLAYER_CONDITION_PITCHER_ERROR, err));
            });
    };
};

const convertPlayerConditionPitcher = (data) => {
    if (data) {
        const arr = data.map((value, index) => {
            let head = {text: value.id}
            if (value.opponent_team_name) {
                head = { text: '', img: detectIconById(value.opponent_team_id)}
            } if (value.month) {
                head = { text: value.month + "月"}
            } if (value.opponent_name) {
                head = { text: value.opponent_name}
            } if (value.stadium_name) {
                head = { text: value.stadium_name}
            }
            return {
                item: [
                    head,
                    { text: value.era },
                    { text: value.g },
                    { text: value.cg },
                    { text: value.sho },
                    { text: value.mushikyu },
                    { text: value.w },
                    { text: value.l },
                    { text: value.hld },
                    { text: value.hp },
                    { text: value.sv },
                    { text: numeralFormat(value.wpct, 3) },
                    { text: value.ip + "." + value.ip_frac },
                    { text: value.bf },
                    { text: value.h },
                    { text: value.hr },
                    { text: value.so },
                    { text: value.k9 },
                    { text: value.bb },
                    { text: value.hbp },
                    { text: value.wp },
                    { text: value.bk },
                    { text: value.r },
                    { text: value.er }
                ]
            }
        });
        return arr;
    }
}


const convertPlayerConditionPitcher2 = (data) => {
    if (data) {
        const arr = data.map((value, index) => {
            return {
                item: [
                    { text: value.opponent_name },
                    { text: numeralFormat(value.avg, 3) },
                    { text: value.ab },
                    { text: value.h },
                    { text: value.hr },
                    { text: value.so },
                    { text: value.bb },
                    { text: value.hbp },
                ]
            }
        });
        return arr;
    }
}

const convertPlayerConditionPitcherCommon = (data) => {
    if (data) {
        const arr = data.map((value, index) => {
            return {
                item: [
                    { text: value.name },
                    { text: numeralFormat(value.avg, 3) },
                    { text: value.ab },
                    { text: value.h },
                    { text: value.hr },
                    { text: value.so },
                    { text: value.bb },
                    { text: value.hbp },
                ]
            }
        });
        return arr;
    }
}

export {
    ACTIONS_PLAYER, getPlayerConditionPitcher, convertPlayerConditionPitcher,
    convertPlayerConditionPitcher2,
    convertPlayerConditionPitcherCommon
};